import styled from 'styled-components';

export const Content = styled.div`
  min-width: 450px;
  margin-left: 30px;
`;
